import { GraviButton, Texto } from '@gravitate-js/excalibrr'
import { useUserSettings } from '@hooks/settings'
import { Button, Tabs, Tooltip } from 'antd'
import queryString from 'query-string'
import type React from 'react'
import { useEffect, useState } from 'react'

export type TabConfig = {
  defaultActive?: boolean // Makes the tab active by default
  title: string
  description: string
  component: React.ReactNode
}
export type MultiGridConfig = {
  tabs: TabConfig[]
  stickStorageKey: string | null // Makes the tab sticky if a key is provided
}

function MultiTabGridTitle({ title, description, activeKey }) {
  return (
    <Tooltip title={description}>
      <GraviButton
        buttonText={title}
        theme2={activeKey === title}
        appearance='text'
        size='small'
        className='pl-3'
        style={{ fontWeight: activeKey === title ? 'bold' : 'inherit' }}
      />
    </Tooltip>
  )
}

export function MultiTabGrid({ tabs, stickStorageKey }: MultiGridConfig) {
  const defaultActiveTab = tabs.find((tab) => tab.defaultActive).title

  const [activeTab, setActiveTab] = useState(defaultActiveTab)
  const { updateSetting, getSetting } = useUserSettings()

  const updateStickyTab = async (key) => {
    setActiveTab(key)
    await updateSetting(stickStorageKey, key)
  }

  useEffect(() => {
    const queryKey = queryString.parse(window.location.search)?.key
    if (queryKey) {
      setActiveTab(defaultActiveTab)
    } else {
      getSetting(stickStorageKey).then((key) => {
        key && setActiveTab(key)
      })
    }
  }, [])

  return (
    <Tabs
      className='credential-tabs '
      defaultActiveKey={activeTab}
      onChange={updateStickyTab}
      activeKey={activeTab}
      style={{
        backgroundColor: 'var(--bg-1)',
        borderRadius: '4px 4px 0 0',
        border: '1px solid var(--gray-200)',
      }}
    >
      {tabs.map((tab) => (
        <Tabs.TabPane
          key={tab.title}
          tab={<MultiTabGridTitle title={tab.title} description={tab.description} activeKey={activeTab} />}
        >
          {tab.component}
        </Tabs.TabPane>
      ))}
    </Tabs>
  )
}
